import { onUnmounted, watch } from "vue"
import { storeToRefs } from "pinia"
import { useHelpStore } from "./help.store"

export function useHelpAudio() {
  const helpStore = useHelpStore()
  const {
    stopAudio,
    removeAudioEventListener,
    startAudioSequence,
    toggleAudio,
  } = helpStore
  const { name, isVolumeActive, isActiveAudioBox } = storeToRefs(helpStore)

  const validAssessments = [
    "Swipe",
    "Shape",
    "Drive",
    "Brain",
    "Move",
    "MoveBis",
  ]

  function handleAudio() {
    if (validAssessments.includes(name.value)) {
      if (!isVolumeActive.value) {
        startAudioSequence()
        toggleAudio(true)
      } else {
        stopAudio()
        toggleAudio(false)
      }
    }
  }

  watch(isActiveAudioBox, (active) => {
    if (!active) removeAudioEventListener()
  })

  onUnmounted(() => {
    removeAudioEventListener()
  })

  return { handleAudio }
}
